// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: "https://restapis-dev.channels.com.sa/ews/api",
  apiUrl: "https://jusur-restapi-dev.channels.com.sa/ews/api",
  FE_URL: 'https://uaen-ewsfe-sit.azurewebsites.net',
  //FE_URL: 'http://localhost:4200',
  OcpApimSubscriptionKey: '1967abb87f804495b3c1a2fa38cde451',
  defaultLang: 'en',
    recaptcha: {
    siteKey: '6LerNcYrAAAAAM7e9IcVRbQZ7idvVbIFOo-p-9im'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
